import { useEffect, useState } from 'react';

import useAnalyzerAmenity from './useAnalyzerAmenity';
import useAnalyzerHomeProfile from './useAnalyzerHomeProfile';
import useAnalyzerLocation from './useAnalyzerLocation';
import useAnalyzerProject from './useAnalyzerProject';
import useAnalyzerSitePlan from './useAnalyzerSitePlan';
import { FB_PIXEL_ID, SEGMENT_WRITE_KEY } from '../../commons/constants';

declare global {
  interface Window {
    ClikTracker: {
      init: (params: {
        segmentId: string;
        facebookPixelId: string;
        analyzerIntializationCallback: (result: any) => void;
      }) => void;
      sendCustomTrack: (action: string, entity: any, params: any) => void;
    };
  }
}

const useAnalyzer = (): void => {
  const [initial, setInitial] = useState<boolean>(false);

  useAnalyzerAmenity({ initial });
  useAnalyzerHomeProfile({ initial });
  useAnalyzerLocation({ initial });
  useAnalyzerProject({ initial });
  useAnalyzerSitePlan({ initial });

  useEffect(() => {
    if (initial || !window || !window.ClikTracker || !window.ClikTracker.init) return;
    window.ClikTracker.init({
      segmentId: SEGMENT_WRITE_KEY,
      facebookPixelId: FB_PIXEL_ID,
      analyzerIntializationCallback: (result) => {
        if (result && result.errorType === 0 && result.message === '') setInitial(true);
      },
    });
  }, [window && window.ClikTracker]);
};

export default useAnalyzer;
